import { useEffect, useState } from "react";

interface Props {
  /** Wall-clock millis when the timer should reach 0. */
  endAt: number | null;
  /** Total duration in seconds — used to colour the timer when running low. */
  totalSeconds: number;
  onExpire?: () => void;
}

export default function Timer({ endAt, totalSeconds, onExpire }: Props) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!endAt) return;
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, [endAt]);

  if (!endAt) return <span className="timer">--</span>;
  const remainingMs = Math.max(0, endAt - now);
  const remainingSec = Math.ceil(remainingMs / 1000);
  const tone = remainingSec === 0 ? "danger" : remainingSec <= Math.max(5, totalSeconds * 0.2) ? "warning" : "";

  useEffect(() => {
    if (remainingMs === 0) onExpire?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingMs === 0]);

  const min = Math.floor(remainingSec / 60);
  const sec = remainingSec % 60;
  return (
    <span className={`timer ${tone}`} aria-live="polite">
      {String(min).padStart(2, "0")}:{String(sec).padStart(2, "0")}
    </span>
  );
}
